import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CategoryRoutingModule } from './category-routing.module';
import { CategoryComponent } from './category.component';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CustomFlexLayoutModule } from 'src/app/flex-layout/custom-flex-layout.module';
import { NestedSideMenuChildComponent } from './nested-side-menu-child/nested-side-menu-child.component';


@NgModule({
  declarations: [CategoryComponent, NestedSideMenuChildComponent],
  imports: [
    CommonModule,
    CategoryRoutingModule,
    MatListModule,
    MatIconModule,
    MatRippleModule,
    MatButtonModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    CustomFlexLayoutModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]


})
export class CategoryModule { }
